import React, { Component } from "react";
import "./styling/App.css";
import backgroundRectangle from "./images/background-rectangle.png";
import styled from "styled-components";
import Result from "./components/Result";
import Input from "./components/Input";
import "react-sliding-pane/dist/react-sliding-pane.css";
import * as logic from "./logic/Logic";

const Container = styled.div``;

const Content = styled.div`
  background-color: #f0f2f5;
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {
        rechercheAufwand: 0,
        bruttoGehalt: 0,
        wochenarbeitszeit: 0,
      },
      result: {
        zeitersparnisProMonat: 0,
        zeitersparnisProJahr: 0,
        einsparpotenzialProMonat: 0,
        einsparpotenzialProJahr: 0,
      },
    };
  }

  updateCalculation = () => {
    const round = (num, decimalPlaces) => {
      return +(Math.round(num + "e+" + decimalPlaces) + "e-" + decimalPlaces);
    };

    this.setState((state) => {
      const { rechercheAufwand, bruttoGehalt, wochenarbeitszeit } = state.input;
      return {
        result: {
          zeitersparnisProMonat:
            logic.calculateZeitersparnisProMonat(rechercheAufwand),
          zeitersparnisProJahr:
            round(logic.calculateZeitersparnisProMonat(rechercheAufwand), 0) *
            12,
          einsparpotenzialProMonat: logic.calculateEinsparpotenzialProMonat(
            bruttoGehalt,
            wochenarbeitszeit,
            rechercheAufwand
          ),
          einsparpotenzialProJahr:
            round(
              logic.calculateEinsparpotenzialProMonat(
                bruttoGehalt,
                wochenarbeitszeit,
                rechercheAufwand
              ),
              0
            ) * 12,
        },
      };
    });
  };

  componentDidMount() {
    this.updateCalculation();
  }

  updateInput = (input) => {
    this.setState({ input });
    this.updateCalculation();
  };

  render() {
    return (
      <Container>
        <Content className="grid-container">
          <div className="left">
            <Input onValueChange={this.updateInput} />
          </div>
          <div className="right">
            <img
              alt="Hintergrund Rechteck"
              className="backgroundRectangle"
              src={backgroundRectangle}
            />
            <div className="backgroundLines"></div>
            <div className="results">
              <section className="ok">
                <Result
                  rechercheAufwand={this.state.input.rechercheAufwand}
                  zeitersparnisProMonat={
                    this.state.result.zeitersparnisProMonat
                  }
                  zeitersparnisProJahr={this.state.result.zeitersparnisProJahr}
                  einsparpotenzialProMonat={
                    this.state.result.einsparpotenzialProMonat
                  }
                  einsparpotenzialProJahr={
                    this.state.result.einsparpotenzialProJahr
                  }
                />
              </section>
            </div>
          </div>
        </Content>
      </Container>
    );
  }
}

export default App;
